import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input } from 'components';
import { formActions, httpRequestsOnSuccessActions } from 'store';
import { FindLoad, useModal, FindSuccessItem } from 'utils';

const ACTION_TYPE = 'RESEND_INVITE_FORM';

export const ResendIntakeForm = ({ client }) => {
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();
    const { handleSubmit, control, reset } = useForm();

    useEffect(() => {
        if (client?.email) {
            reset({ email: client?.email });
        } else {
            reset({});
        }
    }, [client]);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            close();
        }
    }, [success]);

    const handleCreate = (data) => {
        dispatch(formActions.resendInviteForm({ ...data, clientId: client?.id }));
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">Resend Intake Form</p>
            <p className="modal-header-sub">Enter the client’s email to resend the intake form link.</p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <Input
                        type="email"
                        name="email"
                        label="Email Address*"
                        variant="outlined"
                        control={control}
                        rules={{
                            required: 'Email Address is required.',
                        }}
                    />
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={'Resend Form'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'16px'}
                />
            </form>
        </div>
    );
};
